<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import { useQuery } from '@vue/apollo-composable'
import gql from 'graphql-tag'
import {
  ArchivedConfigurationAlertDataQuery,
  ArchivedConfigurationAlertDataQueryVariables,
} from '@/generated/graphql'
import ArchiveNotice from '@/components/archive/ArchiveNotice.vue'

const props = defineProps<{
  productConfigurationId: string
}>()

const { t } = useI18n()

const fetchQuery = useQuery<
  ArchivedConfigurationAlertDataQuery,
  ArchivedConfigurationAlertDataQueryVariables
>(
  gql`
    query ArchivedConfigurationAlertData($productConfigurationId: ID!) {
      product {
        productConfiguration(id: $productConfigurationId) {
          id
          archived
          product {
            id
          }
        }
      }
    }
  `,
  () => ({ productConfigurationId: props.productConfigurationId }),
)
const config = computed(() => fetchQuery.result.value?.product.productConfiguration)
</script>

<template>
  <archive-notice
    v-if="config?.archived"
    class="mt-4"
    :message="t('component.archive.configurationArchived')"
  >
    <template #action>
      <v-btn
        variant="text"
        color="primary"
        append-icon="arrow_forward"
        :to="{ name: 'productConfigurations', params: { productId: config.product.id } }"
      >
        {{ t('component.archive.openConfigurations') }}
      </v-btn>
    </template>
  </archive-notice>
</template>

<style scoped lang="scss"></style>
